// extracted by mini-css-extract-plugin
module.exports = {"ctnr":"about_ctnr__2wtHj","title":"about_title__2IENN","test":"about_test__2e6B4","imgLSYG":"about_imgLSYG__kf3gk"};